module.exports = __webpack_public_path__ + "img/mirror14.1757aca2.jpg";